import React from 'react';
import {useStyles} from "./PackageSalePrices.style";
import { Observer } from 'mobx-react-lite';
import PackageSalePricesProperties from './PackageSalePricesProperties';
import TabOption from '../../../../ui_components/Tab/TabOption';
import Tabs from '../../../../ui_components/Tab/Tabs';
import ReferenceItemSalePrices from './ReferenceItems/ReferenceItemSalePrices';
import CustomCategorySalePrices from './CustomCategories/CustomCategorySalePrices';


const PackageSalePrices: React.FC<PackageSalePricesProperties> = ({
    salePrice,
    onUpdate = () => {
    },
}) => {
    const classes = useStyles();

    const tabsContent = [
        new TabOption("Categorias", <CustomCategorySalePrices salePrice={salePrice} onUpdate={onUpdate}/>),
        new TabOption("Artículos de referencia", <ReferenceItemSalePrices salePrice={salePrice} onUpdate={onUpdate}/>),
    ];

    return (
        <Observer>
            {() => (
                <div className={classes.package_tab_container}>
                    <Tabs content={tabsContent}/>
                </div>
            )}
        </Observer>
    )
}

export default PackageSalePrices;
